import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import axios from "axios";
import Input from "@mui/joy/Input";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import { useForm, Controller } from "react-hook-form";

export const votingCategories = [
  "artysta",
  "producent",
  "dj",
  "album",
  "impreza",
  "wydarzenie",
  "teledysk",
];

const Voting = () => {
  const [votingCards, setVotingCards] = useState([]);
  const [votes, setVotes] = useState([]);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  // const [errors, setErrors] = useState([]);
  const [buttonState, setButtonState] = useState("ZAGŁOSUJ!");

  useEffect(() => {
    navigate("/wyniki");
   //  axios
   //    .get(`${process.env.REACT_APP_API}/show-votecards`)
   //    .then((response) => {
   //      setVotingCards(response.data);
   //    });
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    control,
    getValues,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      artysta: "",
      producent: "",
      dj: "",
      album: "",
      impreza: "",
      wydarzenie: "",
      teledysk: "",
      email: "",
    },
  });

  const watchFields = watch(votingCategories);

  const handleOnSubmit = async (data) => {
    const mappedData = Object.entries(data).reduce((acc, [key, value]) => {
      const [, v] = value.split(`${key}_`);
      acc[key] = v === undefined ? "" : v;
      return acc;
    }, {});
    const mappedDataWithEmail = { ...mappedData, email: data.email };
    return axios
      .post(`${process.env.REACT_APP_API}/add-vote`, mappedDataWithEmail)
      .then((response) => {
        alert(
          `Na podany adres e-mail ${
            JSON.parse(response.config.data).email
          } zostanie wysłany link`
        );
        setMessage(
          "Dziękujemy za oddanie głosu. Pamiętaj, że głos niepotwierdzony mailowo nie bierze udziału w zabawie!"
        );
      })
      .catch((error) => {
        console.log(error.data);
        setMessage("Każdy może oddać jeden głos.");
      });
  };

  const onSubmitError = async (error) => {
    // setErrors(error)

    console.log(error, Object.keys(error));
  };

  return (
    <>
      <div className="p-5 mx-5 bg-gradient-to-b from-[#e2ce9d] to-[#f9b866]">
        <div className="max-w-4xl mx-auto">
          <div className="mx-auto mt-5 text-center text-2xl font-[Bold] text-[#503854]">
            GŁOSOWANIE
          </div>{" "}
          <div className="p-1 w-full mt-5 drop-shadow-xl bg-[#503854] rounded" />
          <div className="p-2 mt-5 font-[light] uppercase">
            Witaj w drugim etapie PODSUMOWANIA ROKU 2024 na poznańskiej scenie
            hip-hopowej. Wybierz po jednej pozycji z siedmiu dostępnych
            kategorii: Artysta, Producent, Dj, Album, Teledysk, impreza oraz
            Wydarzenie Roku. Pamiętaj, aby Twój głos był brany pod uwagę musisz
            potwierdzić go mailowo! Dziękujemy za udział w zabawie!
          </div>
          <form onSubmit={handleSubmit(handleOnSubmit, onSubmitError)}>
            {votingCategories.map((votingCategory, i) => {
              return (
                <div
                  key={`annual-category-separator-container_${votingCategory}`}
                >
                  <div className="p-1 my-10 mb-5 flex flex-wrap justify-center bg-[#503854] rounded font-[Light]">
                    <div className="p-1 font-[Bold] uppercase text-gray-50">
                      {`${i + 1 + ". " + votingCategory} roku ${
                        new Date().getFullYear() - 1
                      }`}
                    </div>
                  </div>

                  <div className="flex flex-wrap flex-row gap-5 justify-center">
                    {votingCards
                      .filter(
                        (votingCard) => votingCard.category === votingCategory
                      )
                      .map((voteCard, index) => {
                        const isChecked = watchFields.includes(
                          `${votingCategory}_${voteCard.name}`
                        );
                        switch (voteCard.category) {
                          case "teledysk":
                            return (
                              <div
                                key={`input_id_${voteCard.name}_${voteCard.category}`}
                                value={voteCard.name}
                              >
                                <input
                                  type="radio"
                                  id={`category_${votingCategory}_${index}`}
                                  name={`category_${votingCategory}`}
                                  value={`${votingCategory}_${voteCard.name}`}
                                  className="hidden peer"
                                  {...register(`${votingCategory}`, {
                                    required: {
                                      value: true,
                                      message: "Każde pole jest wymagane!",
                                    },
                                  })}
                                />
                                <label
                                  htmlFor={`category_${votingCategory}_${index}`}
                                  className="flex transition ease delay-200
																	 flex-col-reverse border-2 z-10 w-66 h-72 items-center justify-between p-2
																	 text-gray-400 border-gray-100 cursor-pointer peer-checked:text-[#e2ce9d]
																	 peer-checked:border-violet-500 peer-checked:bg-[#671e8e] hover:text-gray-100 hover:border-violet-400 hover:bg-[#503854]
																	   bg-gray-800 rounded-lg"
                                >
                                  <div
                                    className="flex flex-col place-self-start h-full w-full justify-between"
                                    value={`svg_${votingCategory}_${index}`}
                                  >
                                    <div className="mt-2 w-60 uppercase text-center text-sm font-[Bold]">
                                      {voteCard.name}
                                    </div>
                                    <div className="flex">
                                      <div className="mt-2 w-full uppercase text-xs">
                                        {voteCard.category}
                                      </div>
                                      {
                                        <svg
                                          key={`svg_${index}_${votingCategory}`}
                                          id={`svg_${index}_${votingCategory}`}
                                          className={`w-6 h-6 place-self-center ${
                                            isChecked || "scale-0"
                                          } transition ease delay-500`}
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="currentColor"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M5 13l4 4L19 7"
                                          ></path>
                                        </svg>
                                      }
                                    </div>
                                  </div>
                                  <div className="flex items-center">
                                    <iframe
                                      src={`https://www.youtube-nocookie.com/embed/${voteCard.video}?enablejsapi=1`}
                                      key={`iframe_${index}_${votingCategory}`}
                                      title="YouTube video player"
                                      allowFullScreen={true}
                                      referrerPolicy="no-refferer"
                                      sandbox="allow-scripts allow-same-origin"
                                      loading="lazy"
                                      className={`w-64 border-2 rounded-lg hover:border-violet-400 delay-150' ${
                                        isChecked
                                          ? "border-violet-500"
                                          : " border-grey-100}"
                                      }`}
                                    />
                                  </div>
                                </label>
                              </div>
                            );
                          default:
                            return (
                              <div
                                key={`input_id_${voteCard.name}_${voteCard.category}`}
                                value={voteCard.name}
                              >
                                <input
                                  type="radio"
                                  id={`category_${votingCategory}_${index}`}
                                  name={`category_${votingCategory}`}
                                  key={`input_${index}_${votingCategory}`}
                                  value={`${votingCategory}_${voteCard.name}`}
                                  className="hidden peer"
                                  {...register(`${votingCategory}`, {
                                    required: {
                                      value: true,
                                      message: "Każde pole jest wymagane!",
                                    },
                                  })}
                                />
                                <label
                                  htmlFor={`category_${votingCategory}_${index}`}
                                  className="flex flex-row transition ease delay-200
																	 z-10 w-66 justify-between p-2 bg-[#503854d2] border-2 rounded-lg
																	  cursor-pointer text-gray-400 border-gray-100 peer-checked:text-[#e2ce9d]
																	   peer-checked:border-violet-500 peer-checked:bg-[#671e8e] hover:text-gray-100 hover:border-violet-400 hover:bg-[#503854]
																	     bg-gray-800"
                                  key={`label_${index}_${votingCategory}`}
                                >
                                  <div
                                    className="flex flex-col justify-between"
                                    key={`vote-info-container_${votingCategory}_${index}`}
                                  >
                                    <div
                                      key={`vote-info-name_${index}_${votingCategory}`}
                                      className="w-[150px] uppercase text-sm font-[Bold]"
                                    >
                                      {voteCard.name}
                                    </div>
                                    <div
                                      key={`vote-info-category_${index}_${votingCategory}`}
                                      className="w-full uppercase text-xs"
                                    >
                                      {voteCard.category}
                                    </div>
                                  </div>
                                  <div
                                    className="flex items-end"
                                    key={`svg-container_${index}_${votingCategory}`}
                                  >
                                    {
                                      <svg
                                        key={`svg_${index}_${votingCategory}`}
                                        id={`svg_${index}_${votingCategory}`}
                                        className={`w-6 h-6 mr-3 ${
                                          isChecked || "scale-0"
                                        } transition ease delay-500`}
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          key={`svg-path_${index}_${votingCategory}`}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M5 13l4 4L19 7"
                                        ></path>
                                      </svg>
                                    }
                                    <div
                                      className="flex h-full"
                                      key={`img-container_${index}_${votingCategory}`}
                                    >
                                      <img
                                        key={`img_${index}_${votingCategory}`}
                                        className={`w-20 h-20 border-2 rounded-lg delay-150 ${
                                          isChecked
                                            ? "border-violet-500"
                                            : "border-grey-100 hover:borde"
                                        }`}
                                        src={`${process.env.REACT_APP_API_DOMAIN}/images/${voteCard.image}`}
                                        loading="lazy"
                                      />
                                    </div>
                                  </div>
                                </label>
                              </div>
                            );
                        }
                      })}
                  </div>

                  <div></div>
                </div>
              );
            })}
            <div className="p-1 flex flex-wrap justify-around">
              <div className="p-1 w-full max-w-2xl mt-5 drop-shadow-xl bg-[#503854] rounded" />
              <div className="px-8 gap-10 max-w-3xl flex-col pb-5 mt-5 drop-shadow-xl bg-[#503854] rounded">
                <div className="bg-gradient-to-b items-center from-[#f9b866] w-60 mx-auto  to-[#503854] rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                  <Controller
                    rules={{
                      required: {
                        value: true,
                        message: "To pole jest wymagane",
                      },
                      maxLength: {
                        value: 100,
                        message: "maksymalna ilosc znakow to 100",
                      },
                      minLength: {
                        value: 5,
                        message: "minimalna ilosc znakow to 5",
                      },
                      pattern: {
                        value:
                          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: "ten adres email nie istnieje",
                      },
                    }}
                    control={control}
                    name="email"
                    render={({ field }) => {
                      return (
                        <Input
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          className="w-full"
                          placeholder="Twój adres email..."
                          color="info"
                          variant="outlined"
                          autoComplete="off"
                          key="email"
                        />
                      );
                    }}
                  />
                  <div className="p-1 font-[Bold] uppercase text-center text-gray-50">
                    twÓj adres email
                  </div>
                </div>
                {errors && Object.keys(errors).length > 0 && (
                  <div className="relative">
                    <pre className="flex font-bold text-amber-300 uppercase  mt-1">{`Każde pole jest wymagane!\nBrakujące pola:\n`}</pre>
                    {Object.entries(errors).map((errorEntry) => {
                      switch (errorEntry[1].type) {
                        case "required":
                          return (
                            <span
                              key={errorEntry[0]}
                              className="flex font-bold text-sm text-amber-300 uppercase  mt-1"
                            >
                              {errorEntry[1].message !== "" &&
                                `${errorEntry[0]}`}
                            </span>
                          );
                        default:
                          return (
                            <span
                              key={errorEntry[0]}
                              className="flex font-bold text-sm mb-5 text-amber-300 uppercase  mt-3"
                            >
                              {errorEntry[1].message !== "" &&
                                `${errorEntry[0]}: `}
                              <br />
                              {errorEntry[1].message}
                            </span>
                          );
                      }
                    })}
                  </div>
                )}

                <div className="mt-5 self-center text-center py-1">
                  <Button
                    id="submit-votes-button"
                    type="submit"
                    variant="contained"
                    color="secondary"
                    endIcon={<SendIcon />}
                  >
                    <b className="h-7/8 self-end">{buttonState}</b>
                  </Button>
                </div>
                {message && (
                  <b className="h-7/8 self-end text-[#f9b866]">{message}</b>
                )}
              </div>
            </div>
            <div className="p-1 mb-3 w-full mt-5 drop-shadow-xl bg-[#503854] rounded" />
          </form>
        </div>
      </div>
    </>
  );
};

export default Voting;
